/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../types';

import * as TypescriptOperationsGenerated from "graphql/typescript-operations.generated"
import * as Operations from 'graphql/document-nodes.generated';
import { NextPage } from 'next';
import { NextRouter, useRouter } from 'next/router'
import { QueryHookOptions, useQuery } from '@apollo/client';
import * as Apollo from '@apollo/client';
import type React from 'react';
import { getApolloClient , ApolloClientContext} from 'withApollo';
export async function getServerPageGetGlobal
    (options: Omit<Apollo.QueryOptions<TypescriptOperationsGenerated.GetGlobalQueryVariables>, 'query'>, ctx: ApolloClientContext ){
        const apolloClient = getApolloClient(ctx);
        
        const data = await apolloClient.query<TypescriptOperationsGenerated.GetGlobalQuery>({ ...options, query: Operations.GetGlobalDocument });
        
        const apolloState = apolloClient.cache.extract();

        return {
            props: {
                apolloState: apolloState,
                data: data?.data,
                error: data?.error ?? data?.errors ?? null,
            },
        };
      }
export const useGetGlobal = (
  optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetGlobalQuery, TypescriptOperationsGenerated.GetGlobalQueryVariables>) => {
  const router = useRouter();
  const options = optionsFunc ? optionsFunc(router) : {};
  return useQuery(Operations.GetGlobalDocument, options);
};
export type PageGetGlobalComp = React.FC<{data?: TypescriptOperationsGenerated.GetGlobalQuery, error?: Apollo.ApolloError}>;
export const withPageGetGlobal = (optionsFunc?: (router: NextRouter)=> QueryHookOptions<TypescriptOperationsGenerated.GetGlobalQuery, TypescriptOperationsGenerated.GetGlobalQueryVariables>) => (WrappedComponent:PageGetGlobalComp) : NextPage  => (props) => {
                const router = useRouter()
                const options = optionsFunc ? optionsFunc(router) : {};
                const {data, error } = useQuery(Operations.GetGlobalDocument, options)    
                return <WrappedComponent {...props} data={data} error={error} /> ;
                   
            }; 
export const ssrGetGlobal = {
      getServerPage: getServerPageGetGlobal,
      withPage: withPageGetGlobal,
      usePage: useGetGlobal,
    }